import React from 'react';
import './RSVP.css';

const RSVP = () => {
  return (
    <section id="rsvp" className="rsvp section">
      <div className="container">
        <h2 className="rsvp-title">RSVP</h2>
        <p className="rsvp-subtitle">
          Please respond by <b>October 31st, 2026</b><br/>
          Don't panic if you need to change your response - you can do it any time before the deadline! <br/>
          If you have any questions, please contact us at <a href="mailto:sontyv@gmail.com">sontyv@gmail.com</a>
        </p>

        <a 
          href="https://forms.gle/6CDkFwtqL1Gp9UAZA" 
          target="_blank" 
          rel="noopener noreferrer"
          className="rsvp-button btn"
        >
          RSVP Now
        </a>
      </div>
    </section>
  );
};

export default RSVP;
